import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=c2f75fd0&scoped=true"
import script from "./topic.vue?vue&type=script&lang=js"
export * from "./topic.vue?vue&type=script&lang=js"
import style0 from "./topic.vue?vue&type=style&index=0&id=c2f75fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f75fd0",
  null
  
)

export default component.exports